module.exports = __webpack_public_path__ + "static/media/start-active.9ebb9644.svg";